import React from "react";
import { Link, useLocation } from "react-router-dom";
import PageHeader from "../../PageHeader";
import FireOnMenu from "../FireOnMenu";

export default function FireAlarmStatisticsComponent() {
  const location = useLocation();
  const { buildingName } = location.state;

  return (
    <section id="darkMode" class="mbSection darkMode">
      <PageHeader isBlack={true} title={buildingName} isUseMenu={true} />
      <div class="container">
        <p class="tableTitle mt-24 pb-10 bb-w">화재경보 발생통계</p>
        <div class="typeMenuWrap">
          <Link
            class="type-item"
            to="/fire-on/fire-alarm-statistics/event-month/"
            state={location.state}
          >
            <p class="type-title">동작 분류별</p>
            <i class="x-icon"></i>
          </Link>
          <Link
            class="type-item"
            to="/fire-on/fire-alarm-statistics/event-type/"
            state={location.state}
          >
            <p class="type-title">이벤트 항목별</p>
            <i class="x-icon"></i>
          </Link>
          <Link
            class="type-item"
            to="/fire-on/fire-alarm-statistics/hour/"
            state={location.state}
          >
            <p class="type-title">발생 시간대별</p>
            <i class="x-icon"></i>
          </Link>
          <Link
            class="type-item"
            to="/fire-on/fire-alarm-statistics/weekday/"
            state={location.state}
          >
            <p class="type-title">발생 요일별</p>
            <i class="x-icon"></i>
          </Link>
        </div>
      </div>
      <FireOnMenu />
    </section>
  );
}
